/* FeedbackScoreButtons.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./FeedbackScoreButtons.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import Button from '@atlaskit/button/new';
import { Text } from '@atlaskit/primitives/compiled';
import Tooltip from '@atlaskit/tooltip';
var tooltipMessage = ['Strongly disagree', 'Disagree', 'Slightly disagree', 'Neutral', 'Slightly agree', 'Agree', 'Strongly agree'];
var buttonWrapperStyles = null;
var descriptionWrapperStyles = null;
export default (function (_ref) {
  var onChange = _ref.onChange,
    value = _ref.value;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: ax(["_1e0c1txw _1bah1yb4 _zdxokb7n _v5ynkb7n _13lsf1ug _1o0a1h6o _pof3u2gc"])
  }, Array.from({
    length: 7
  }, function (_, i) {
    var score = i + 1;
    var isSelected = value === score;
    return /*#__PURE__*/React.createElement(Tooltip, {
      content: tooltipMessage[i],
      key: score,
      hideTooltipOnClick: true
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return onChange(score);
      },
      isSelected: isSelected,
      "aria-pressed": isSelected,
      "aria-describedby": "contextualSurveyStatement",
      "aria-label": tooltipMessage[i],
      shouldFitContainer: true
    }, score));
  })), /*#__PURE__*/React.createElement("div", {
    "aria-hidden": true,
    className: ax(["_1e0c1txw _19pku2gc _otyr1ejb _1bah1yb4 _nbgx1epz"])
  }, /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtlest",
    size: "UNSAFE_small",
    weight: "semibold",
    align: "start"
  }, "Strongly disagree"), /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtlest",
    size: "UNSAFE_small",
    weight: "semibold",
    align: "center"
  }, "Neutral"), /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtlest",
    size: "UNSAFE_small",
    weight: "semibold",
    align: "end"
  }, "Strongly agree")));
});